export const ApiEnum = Object.freeze({
    //Prod:
    BACKEND: '/citsoa-recarga/v1',

    //LocalHost:
    //BACKEND: '/citsbe-recarga-service',

    CRIAR_COBRANCA: '/v2/recebimentos/cob/'
});